import { render, staticRenderFns } from "./WorkersAdminPage.vue?vue&type=template&id=93fff364&"
import script from "./WorkersAdminPage.vue?vue&type=script&lang=js&"
export * from "./WorkersAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports